var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1442,
    height: 659,
    viewBox: "0 0 1442 659",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter0_d_687_133)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M210.23 238.07C108.412 238.07 20.3737 297.967 -21.568 384.949C-50.039 443.994 -100.195 499.947 -164.946 499.947C-229.697 499.947 -283.626 445.888 -268.403 381.989C-216.185 162.801 -21.703 0 210.23 0C311.011 0 404.721 30.7392 482.761 83.4868C542.892 124.13 627.92 124.13 688.051 83.4867C766.091 30.7392 859.8 0 960.582 0C1232.54 0 1453 223.834 1453 499.947C1453 955.088 1138.88 1357 714.373 1357C327.249 1357 31.9265 1022.76 -17.0857 618.715C-25.0006 553.467 28.2365 499.947 92.9877 499.947C157.739 499.947 209.176 553.636 219.294 618.57C265.561 915.515 482.28 1118.93 714.373 1118.93C976.228 1118.93 1218.52 859.999 1218.52 499.947C1218.52 355.317 1103.03 238.07 960.582 238.07C858.764 238.07 770.725 297.967 728.784 384.949C700.313 443.994 650.157 499.947 585.406 499.947C520.655 499.947 470.499 443.994 442.028 384.949C400.086 297.967 312.048 238.07 210.23 238.07Z",
    fill: "url(#paint0_linear_687_133)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.23 237.07C108.008 237.07 19.6306 297.206 -22.4688 384.515C-50.8982 443.474 -100.8 498.947 -164.946 498.947C-229.211 498.947 -282.468 445.344 -267.43 382.221C-215.314 163.463 -21.2199 1 210.23 1C310.805 1 404.321 31.6754 482.201 84.3153C542.67 125.187 628.142 125.187 688.611 84.3152C766.491 31.6754 860.007 1 960.582 1C1231.97 1 1452 224.372 1452 499.947C1452 954.711 1138.17 1356 714.373 1356C327.894 1356 32.8767 1022.29 -16.093 618.595C-23.9276 554.008 28.7679 500.947 92.9877 500.947C157.142 500.947 208.247 554.166 218.306 618.724C264.629 916.027 481.667 1119.93 714.373 1119.93C976.926 1119.93 1219.52 860.393 1219.52 499.947C1219.52 354.779 1103.6 237.07 960.582 237.07C858.36 237.07 769.982 297.206 727.883 384.515C699.454 443.474 649.551 498.947 585.406 498.947C521.261 498.947 471.358 443.474 442.929 384.515C400.83 297.206 312.452 237.07 210.23 237.07Z",
    stroke: "#F7BDBA",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_687_133",
    x: -275,
    y: 0,
    width: 1732,
    height: 1365,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_687_133"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_687_133",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_687_133",
    x1: -139.25,
    y1: 149.254,
    x2: 1230.75,
    y2: 971.053,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEDCDA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnionIcon);
export default __webpack_public_path__ + "static/media/union-icon.1212d12b1c0e04f6f272589fc1f598b5.svg";
export { ForwardRef as ReactComponent };